import { useEffect, useState } from 'react';
import { adminApi } from '../../api/adminApi';

export default function ReviewsAdmin() {
  const [reviews, setReviews] = useState<any[]>([]);
  const [answers, setAnswers] = useState<{ [key: number]: string }>({});
  const [itemTypes, setItemTypes] = useState<{ [key: number]: boolean }>({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // --- Стан для кастомного модального вікна ---
  const [modal, setModal] = useState<{
    show: boolean;
    title: string;
    message: string;
    onConfirm?: () => void;
    isConfirm?: boolean;
  }>({ show: false, title: '', message: '' });

  const showAlert = (title: string, message: string) => {
    setModal({ show: true, title, message, isConfirm: false });
  };

  const showConfirm = (title: string, message: string, onConfirm: () => void) => {
    setModal({ show: true, title, message, onConfirm, isConfirm: true });
  };

  const closeModal = () => setModal(prev => ({ ...prev, show: false }));
  // -------------------------------------------

  const load = async () => {
    try {
      const data = await adminApi.getReviews();
      // Сортуємо: спочатку неперевірені (is_approved: false)
      const sortedData = data.sort((a: any, b: any) => Number(a.is_approved) - Number(b.is_approved));
      setReviews(sortedData);
      
      const types: { [key: number]: boolean } = {};
      data.forEach((r: any) => { 
        types[r.id] = r.is_feedback || false; 
        if (r.answer) {
          setAnswers(prev => ({ ...prev, [r.id]: r.answer }));
        }
      });
      setItemTypes(types);
    } catch (err: any) {
      if (err?.status === 401) showAlert('Сесія', 'Сесія закінчилась. Увійдіть знову.');
    }
  };

  useEffect(() => { load(); }, []);

  const handleAnswer = async (id: number) => {
    const answer = answers[id] || '';
    const isFeedback = itemTypes[id];

    try {
      await adminApi.answerReview(id, answer, isFeedback); 
      showAlert('Успіх', 'Дані збережено та відгук схвалено!');
      load();
    } catch (err) {
      showAlert('Помилка', 'Не вдалося зберегти відповідь');
    }
  };

  const handleDelete = async (id: number) => {
    showConfirm('Видалення', 'Ви впевнені, що хочете видалити цей відгук?', async () => {
      try {
        await adminApi.deleteReview(id);
        load();
      } catch (err) {
        showAlert('Помилка', 'Не вдалося видалити');
      }
    });
  };

  const currentReviews = reviews.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const totalPages = Math.ceil(reviews.length / itemsPerPage);

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'Montserrat, sans-serif', backgroundColor: '#f0f7f4', minHeight: '100vh' }}>
      
      {/* КАСТОМНЕ МОДАЛЬНЕ ВІКНО */}
      {modal.show && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h4 style={{ marginTop: 0, color: '#2d5a50' }}>{modal.title}</h4>
            <p style={{ color: '#666', fontSize: '15px', marginBottom: '25px' }}>{modal.message}</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              {modal.isConfirm && (
                <button onClick={closeModal} style={modalSecondaryBtnStyle}>Скасувати</button>
              )}
              <button 
                onClick={() => { modal.onConfirm?.(); closeModal(); }} 
                style={modalPrimaryBtnStyle}
              >
                ОК
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h2 style={{ margin: 0, color: '#2d5a50' }}>💬 Модерація (Питання / Відгуки)</h2>
        <div style={{ background: '#fff', padding: '8px 16px', borderRadius: '10px', color: '#2d5a50', fontWeight: 'bold', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
          Всього: {reviews.length}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {currentReviews.map(r => (
          <div key={r.id} style={{ display: 'flex', background: '#fff', borderRadius: '12px', border: '1px solid #eee', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
            <div style={{ width: '8px', background: r.is_approved ? '#1abc9c' : '#ffc107' }} />

            <div style={{ display: 'flex', width: '100%', padding: '20px', gap: '20px', flexWrap: 'wrap' }}>
              
              <div style={{ flex: 1, minWidth: '300px', borderRight: '1px solid #f0f0f0', paddingRight: '20px' }}>
                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontWeight: 700, color: '#2d5a50' }}>
                    👤 {r.user_name || 'Анонім'} 
                  </span>
                  <span style={{ fontSize: '11px', color: '#aaa' }}>ID: {r.id}</span>
                </div>
                <div style={{ background: '#fcfcfc', padding: '15px', borderRadius: '10px', border: '1px solid #f0f0f0' }}>
                  <p style={{ margin: 0, color: '#444', lineHeight: '1.5' }}>{r.question}</p>
                </div>
              </div>

              <div style={{ width: '320px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', background: '#f0f0f0', padding: '4px', borderRadius: '8px' }}>
                  <button 
                    onClick={() => setItemTypes(prev => ({ ...prev, [r.id]: false }))}
                    style={{ 
                      flex: 1, padding: '8px', border: 'none', borderRadius: '6px', cursor: 'pointer',
                      background: !itemTypes[r.id] ? '#fff' : 'transparent',
                      fontWeight: !itemTypes[r.id] ? 'bold' : 'normal',
                      boxShadow: !itemTypes[r.id] ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                      transition: 'all 0.2s'
                    }}
                  >❓ Питання</button>
                  <button 
                    onClick={() => setItemTypes(prev => ({ ...prev, [r.id]: true }))}
                    style={{ 
                      flex: 1, padding: '8px', border: 'none', borderRadius: '6px', cursor: 'pointer',
                      background: itemTypes[r.id] ? '#fff' : 'transparent',
                      fontWeight: itemTypes[r.id] ? 'bold' : 'normal',
                      boxShadow: itemTypes[r.id] ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                      transition: 'all 0.2s'
                    }}
                  >⭐ Відгук</button>
                </div>

                <textarea
                  placeholder={itemTypes[r.id] ? "Коментар адміна (не обов'язково)" : "Відповідь спеціаліста..."}
                  value={answers[r.id] || ''}
                  onChange={e => setAnswers(prev => ({ ...prev, [r.id]: e.target.value }))}
                  style={{ width: '100%', height: '90px', padding: '12px', borderRadius: '10px', border: '1px solid #ddd', resize: 'none', outline: 'none', fontSize: '14px' }}
                />

                <div style={{ display: 'flex', gap: '10px' }}>
                  <button 
                    onClick={() => handleAnswer(r.id)} 
                    style={{ flex: 2, padding: '12px', background: '#1abc9c', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    Зберегти
                  </button>
                  <button 
                    onClick={() => handleDelete(r.id)} 
                    style={{ flex: 1.2, padding: '12px', background: '#fff', color: '#dc3545', border: '1px solid #dc3545', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}
                  >
                    Видалити
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '40px' }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <button 
              key={i + 1} 
              onClick={() => { setCurrentPage(i+1); window.scrollTo({top: 0, behavior: 'smooth'}); }} 
              style={{ 
                width: '38px', height: '38px', borderRadius: '8px', border: '1px solid #ddd', 
                backgroundColor: currentPage === i + 1 ? '#1abc9c' : '#fff', 
                color: currentPage === i + 1 ? '#fff' : '#333', cursor: 'pointer', fontWeight: 'bold' 
              }}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// --- Стилі модалки ---
const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
  justifyContent: 'center', alignItems: 'center', zIndex: 10000,
  backdropFilter: 'blur(2px)'
};

const modalContentStyle: React.CSSProperties = {
  background: '#fff', padding: '30px', borderRadius: '15px',
  maxWidth: '400px', width: '90%', boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
  textAlign: 'center'
};

const modalPrimaryBtnStyle = {
  padding: '10px 25px', background: '#1abc9c', color: '#fff',
  border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' as const
};

const modalSecondaryBtnStyle = {
  padding: '10px 25px', background: '#eee', color: '#333',
  border: 'none', borderRadius: '8px', cursor: 'pointer'
};